export const onlyDigits = (value) => String(value || '').replace(/\D/g, '');

// До 10 «национальных» цифр из маски «+7 (…)» или из сырых цифр.
// Ведущая 7 снимается только у полного номера (>10 цифр), чтобы не портить
// 10-значные национальные номера, случайно начинающиеся с 7.
export const getNationalPhone = (value) => {
  let digits = onlyDigits(value);
  if (digits.length > 10 && digits[0] === '7') digits = digits.slice(1);
  return digits.slice(0, 10);
};

export const isPhoneComplete = (value) => getNationalPhone(value).length === 10;

export const formatNationalPhone = (value) => {
  const d = getNationalPhone(value);
  let out = '+7';
  if (d.length > 0) out += ` (${d.slice(0, 3)}`;
  if (d.length >= 3) out += ')';
  if (d.length > 3) out += ` ${d.slice(3, 6)}`;
  if (d.length > 6) out += ` ${d.slice(6, 8)}`;
  if (d.length > 8) out += ` ${d.slice(8, 10)}`;
  return out;
};

export const toClientPhone = (value) => `+7${getNationalPhone(value)}`;
